import React from 'react';
import styled from 'styled-components';
import { useNavigate, useMatches } from 'react-router-dom';
import { isEqual } from 'lodash-es';

import { useAppSelector, useAppDispatch, store } from '../../../store';
import { DataElementContext } from '../../../page-components/common/DataElementContext';

type BreadcrumbsProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: {
    dsType: string;
  };
};

const defaultProps = {
  className: '',
  styleText: '',
  properties: {
    dsType: '',
  },
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const fetchBreadCrumbs = (uriMatches: any) => {
  const [match, setMatch] = React.useState<any>({
    hasMatch: false,
    pathname: '',
    params: {},
    paths: [],
    title: '…',
    allowLoginButtonInRegisterPage: true,
  });

  const dataSources = useAppSelector((state) => state.dataSources.items);

  React.useEffect(() => {
    if (uriMatches && uriMatches.length) {
      // console.log('Breadcrumbs[state]', { fullLiveStateLoaded, fullPrematchtateLoaded });

      const state = store.getState();

      const uriMatch = uriMatches[uriMatches.length - 1];
      const tmp = {
        hasMatch: true,
        pathname: uriMatch.pathname,
        params: uriMatch.params,
        paths: [
          {
            uri: '/',
            label: 'Home',
          },
        ],
        title: '…',
        allowLoginButtonInRegisterPage: true,
      };

      if (tmp.pathname?.indexOf('/promotions') === 0) {
        tmp.title = 'Promotion';

        if (tmp.pathname === '/promotions/' || tmp.pathname === '/promotions') {
          tmp.title = 'Promotions';
        } else {
          tmp.paths.push({
            uri: '/promotions',
            label: 'Promotions',
          });

          const parts = tmp.pathname.split('/');
          const promotionId = parts[parts.length - 1];

          if (promotionId && dataSources?.all_promotions_api) {
            let promotion = null;
            for (let i = 0; i < dataSources.all_promotions_api.data.length; i++) {
              if (dataSources.all_promotions_api?.data?.[i].id === promotionId) {
                promotion = dataSources.all_promotions_api.data[i];
                break;
              }
            }

            if (promotion && promotion?.message_primary_short) {
              const div = document.createElement('div');
              div.innerHTML = promotion?.message_primary_short;
              tmp.title = div.textContent || div.innerText;
            }
          }
        }
      } else if (tmp.pathname?.indexOf('/profile') === 0) {
        tmp.paths.push({
          uri: '/profile/home',
          label: 'My Account',
        });
      } else if (tmp.pathname?.indexOf('/customer-support') === 0) {
        tmp.paths.push({
          uri: '/customer-support',
          label: 'Help Center',
        });
      } else if (tmp.pathname?.indexOf('/slot-game/') === 0 || tmp.pathname?.indexOf('/live-game/') === 0) {
        tmp.title = 'Login';
      }

      setMatch((v: any) => {
        if (!isEqual(v, tmp)) return tmp;
        return v;
      });
    }
  }, [uriMatches, dataSources]);

  return match;
};

const Breadcrumbs = (componentProps: BreadcrumbsProps) => {
  const tmpProps = { ...defaultProps, ...componentProps };
  delete tmpProps.children;
  const props = JSON.parse(JSON.stringify(tmpProps));
  const { children } = componentProps;

  const uriMatches = useMatches();

  const match = fetchBreadCrumbs(uriMatches);

  // console.log('Breadcrumbs[contextValue]', match);
  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText}>
      <DataElementContext.Provider value={match}>{children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default Breadcrumbs;
